import type { CurrentUser } from '@studio/api-users';
import type { PermissionGroups } from '@studio/core/utils/permission';

import { LoginMode, type SessionState, SessionStateStatus } from './reducer';

function selectLoggedInSessionState(sessionState: SessionState) {
  if (sessionState.status !== SessionStateStatus.LoggedIn) {
    return undefined;
  }
  return sessionState;
}

export function selectUser(
  sessionState: SessionState,
): CurrentUser | undefined {
  return selectLoggedInSessionState(sessionState)?.user;
}

export function selectLoginMode(sessionState: SessionState): LoginMode {
  return selectLoggedInSessionState(sessionState)?.mode ?? LoginMode.Modern;
}

export function selectRealm(sessionState: SessionState): string | undefined {
  return selectUser(sessionState)?.realm;
}

export function selectPermissionGroups(
  sessionState: SessionState,
): PermissionGroups | undefined {
  return (
    selectLoggedInSessionState(sessionState)?.permissionGroups ?? undefined
  );
}
